import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { CustomerService } from "src/app/core/services/customer.service";
import { CustomerSubscriptionItem } from "src/app/shared/models/CustomerSubscription.item";

@Component({
	selector: "app-customer-subscription-record",
	templateUrl: "./customer-subscription-record.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class CustomerSubscriptionRecordComponent implements OnInit {
	@Input() subscriptionItem: CustomerSubscriptionItem;
	@Output() subscriptionItemChange = new EventEmitter<CustomerSubscriptionItem>();

	display = true;

	moment: any = moment;

	constructor(public app: AppService, public customerService: CustomerService) {}

	ngOnInit(): void {
		this.customerService.customer.value.subscriptions.forEach((subscription) => {
			subscription.nextBillDateDate = moment.unix(subscription.nextBillDate).toDate();
			subscription.lastBillDateDate = moment(subscription.lastBillDate).toDate();
		});
	}

	onSave() {
		this.customerService.subscriptionSave(this.subscriptionItem);
	}

	onDelete() {
		this.customerService.subscriptionDelete(this.subscriptionItem.sk);
		this.subscriptionItemChange.emit(undefined);
	}

	setItem() {
		this.subscriptionItem.ooMenuItem = this.customerService.venueService.ooMenuItems.find((item) => item.menuItemKey === this.subscriptionItem.menuItemKey);
	}
}
